import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const moduleLinks = [
    { key: 'footer.modules_production', href: '#features' },
    { key: 'footer.modules_warehouse', href: '#features' },
    { key: 'footer.modules_finance', href: '#features' },
    { key: 'footer.modules_hr', href: '#features' },
    { key: 'footer.modules_quality', href: '#features' },
    { key: 'footer.modules_supply', href: '#features' },
  ];

  const aiLinks = [
    { key: 'footer.ai_assistant', href: '#ai-features' },
    { key: 'footer.ai_qualify', href: '#ai-features' },
    { key: 'footer.ai_demo', href: '#ai-features' },
    { key: 'footer.ai_knowledge', href: '#ai-features' },
  ];

  const companyLinks = [
    { key: 'footer.company_about', to: '/about' },
    { key: 'footer.company_faq', to: '/faq' },
    { key: 'footer.company_careers', to: '/contact' },
    { key: 'footer.company_partners', to: '/contact' },
    { key: 'footer.company_blog', to: '/blog' },
  ];

  const legalLinks = [
    { key: 'footer.legal_privacy', to: '/privacy' },
    { key: 'footer.legal_terms', to: '/terms' },
    { key: 'footer.legal_security', to: '/security' },
  ];

  const columns: { titleKey: string; links: { key: string; href?: string; to?: string }[] }[] = [
    { titleKey: 'footer.modules', links: moduleLinks },
    { titleKey: 'footer.ai', links: aiLinks },
    { titleKey: 'footer.company', links: companyLinks },
    { titleKey: 'footer.legal', links: legalLinks },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
        {/* Top - Link Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {columns.map((col) => (
            <div key={col.titleKey}>
              <p className="text-sm font-semibold text-background-50/90 mb-4 pb-2 border-b border-background-50/15">
                {t(col.titleKey)}
              </p>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) =>
                  link.to ? (
                    <li key={link.key}>
                      <Link
                        to={link.to}
                        className="text-sm text-background-50/55 hover:text-background-50/85 transition-colors duration-200"
                      >
                        {t(link.key)}
                      </Link>
                    </li>
                  ) : (
                    <li key={link.key}>
                      <a
                        href={link.href}
                        className="text-sm text-background-50/55 hover:text-background-50/85 transition-colors duration-200"
                      >
                        {t(link.key)}
                      </a>
                    </li>
                  ),
                )}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-14 md:mt-20 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-baseline gap-2">
            <span className="text-3xl md:text-4xl font-extrabold tracking-tight text-background-50">
              Texio
            </span>
            <span className="hidden sm:inline-block w-6 h-px bg-background-50/30 mx-1"></span>
            <span className="text-xs text-background-50/40">
              {t('footer.copyright')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}